// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-container {
  position: relative;
  width: 100%;
  height: 600px;
}

.graph {
  width: 100%;
  height: 100%;
  background-color: #f9fafb;
  border-radius: 0.5rem;
}

.legend {
  position: absolute;
  top: 1rem;
  left: 1rem;
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  padding: 1rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.legend-title {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #111827;
}

.legend-items {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.legend-color {
  width: 1rem;
  height: 1rem;
  border-radius: 9999px;
}

.legend-color.selected {
  background-color: #c92833;
}

.legend-color.common {
  background-color: #65ccb7;
}

.legend-color.unique {
  background-color: #707070;
}

.legend-label {
  font-size: 0.875rem;
  color: #4b5563;
}`, "",{"version":3,"sources":["webpack://./src/graph/styles/RelationshipGraph.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,0CAA0C;EAC1C,0BAA0B;EAC1B,aAAa;EACb,qBAAqB;EACrB,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".graph-container {\n  position: relative;\n  width: 100%;\n  height: 600px;\n}\n\n.graph {\n  width: 100%;\n  height: 100%;\n  background-color: #f9fafb;\n  border-radius: 0.5rem;\n}\n\n.legend {\n  position: absolute;\n  top: 1rem;\n  left: 1rem;\n  background-color: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(4px);\n  padding: 1rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.legend-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  color: #111827;\n}\n\n.legend-items {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.legend-color {\n  width: 1rem;\n  height: 1rem;\n  border-radius: 9999px;\n}\n\n.legend-color.selected {\n  background-color: #c92833;\n}\n\n.legend-color.common {\n  background-color: #65ccb7;\n}\n\n.legend-color.unique {\n  background-color: #707070;\n}\n\n.legend-label {\n  font-size: 0.875rem;\n  color: #4b5563;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
